export const RoundAwayFromZero = (value: number, decimals: number) => {
  if (value === undefined || value === null) return 0;
  if (decimals === undefined || decimals === null) return value;
  // If decimals is negative, default to 0 (round to nearest integer)
  if (decimals < 0) {
    decimals = 0;
  }
  return +(Math.round(Number(value + 'e+' + decimals)) + 'e-' + decimals);
};

export const CountDecimals = (value: number) => {
  const absValue = Math.abs(value);
  if (Math.floor(absValue.valueOf()) === absValue.valueOf()) return 0;
  const str = absValue.toString();
  if (str.indexOf('.') !== -1 && str.indexOf('-') !== -1) {
    return Number(str.split('-')[1] || 0);
  } else if (str.indexOf('.') !== -1) {
    return Number(str.split('.')[1].length || 0);
  }
  return Number(str.split('-')[1] || 0);
};
